var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleLineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E4FE8E34-9336-45C9-AA95-97B3E1B5CBE2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.4.0-Mojo-SignUp",
    transform: "translate(-849.000000, -395.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-active",
    transform: "translate(760.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signUp-singleLine-icon",
    transform: "translate(87.049638, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3774892,9.4 C7.98295945,9.4 2.9500693,12.5074572 2.93110451,12.519347 L0.951159237,13.8352148 C-0.637164509,14.8610224 -1.00850812,16.2366666 -0.999641485,17.3509193 C-0.989525295,18.2327317 -0.510934105,19.4899279 -0.0110969575,20.7048913 C0.266850578,21.396403 0.775806207,21.8499213 1.33763913,22.0552523 C1.94099466,22.2757585 2.62952865,22.2268703 3.25589261,21.8187708 L7.35399506,19.1620963 C7.83588461,18.8494807 8.22727114,18.410225 8.47110461,17.9559927 C8.75763301,17.4222249 8.877068,16.8691724 8.65100434,16.1079616 C8.61130351,15.9725021 8.58360055,15.8595487 8.56160827,15.5536948 C9.2236093,15.0093608 11.1080444,13.7507328 14.3778865,13.7494336 C17.7740784,13.7507827 19.6748003,15.108067 20.2644634,15.6130255 C20.1987111,15.7944818 20.1409794,15.9869575 20.0503029,16.2949398 C19.9092221,16.7689898 19.971211,17.371568 20.2854242,17.9569093 C20.5292062,18.4110456 20.9205968,18.8501466 21.4033697,19.1625464 L25.5027031,21.8200225 C26.1250167,22.2265165 26.813258,22.2759112 27.4167648,22.0557745 C27.9249802,21.8703965 28.4374002,21.5193757 28.8794889,20.4304204 C29.2514053,19.5286953 29.7443299,18.24787 29.7545856,17.3544404 C29.763486,16.239192 29.3921782,14.8611353 27.8039938,13.8353277 L25.8066005,12.5074572 C25.8066005,12.5074572 20.773753,9.4 14.3774892,9.4 Z",
    id: "Fill-1",
    stroke: "#0964DE",
    transform: "translate(14.377489, 15.791558) rotate(-132.000000) translate(-14.377489, -15.791558) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.8515546,
    y1: 8.51012472,
    x2: 31.5076102,
    y2: 0.151069,
    id: "Line-5",
    stroke: "#45B209",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#45B209",
    strokeLinecap: "round",
    points: "26.6440909 -1.64227436e-12 31.5055513 0.0848571066 31.4206942 4.94631748"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLineIcon);
export default __webpack_public_path__ + "static/media/single-line-icon.dc24193358d0fd3b3fcaa1a53e12c9b2.svg";
export { ForwardRef as ReactComponent };